import { render, staticRenderFns } from "./newsInfoPopUp.vue?vue&type=template&id=e0f60718"
import script from "./newsInfoPopUp.vue?vue&type=script&lang=js"
export * from "./newsInfoPopUp.vue?vue&type=script&lang=js"
import style0 from "./newsInfoPopUp.vue?vue&type=style&index=0&id=e0f60718&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports